__turbopack_context__.v({
  "block": "Skeleton-module-scss-module__O9J6-G__block",
  "circle": "Skeleton-module-scss-module__O9J6-G__circle",
  "delay-1": "Skeleton-module-scss-module__O9J6-G__delay-1",
  "delay-2": "Skeleton-module-scss-module__O9J6-G__delay-2",
  "delay-3": "Skeleton-module-scss-module__O9J6-G__delay-3",
  "delay-4": "Skeleton-module-scss-module__O9J6-G__delay-4",
  "delay-5": "Skeleton-module-scss-module__O9J6-G__delay-5",
  "delay-6": "Skeleton-module-scss-module__O9J6-G__delay-6",
  "h-l": "Skeleton-module-scss-module__O9J6-G__h-l",
  "h-m": "Skeleton-module-scss-module__O9J6-G__h-m",
  "h-s": "Skeleton-module-scss-module__O9J6-G__h-s",
  "h-xl": "Skeleton-module-scss-module__O9J6-G__h-xl",
  "h-xs": "Skeleton-module-scss-module__O9J6-G__h-xs",
  "line": "Skeleton-module-scss-module__O9J6-G__line",
  "skeleton": "Skeleton-module-scss-module__O9J6-G__skeleton",
  "skeleton-loading": "Skeleton-module-scss-module__O9J6-G__skeleton-loading",
  "w-l": "Skeleton-module-scss-module__O9J6-G__w-l",
  "w-m": "Skeleton-module-scss-module__O9J6-G__w-m",
  "w-s": "Skeleton-module-scss-module__O9J6-G__w-s",
  "w-xl": "Skeleton-module-scss-module__O9J6-G__w-xl",
  "w-xs": "Skeleton-module-scss-module__O9J6-G__w-xs",
});
